export default __webpack_public_path__ + "static/media/updated-ISMO.d180b611.pdf";